import React, {useContext, useEffect, useState} from "react";
import Column from "@meridian/components/column";
import Loading from "../commons/Loading";
import {AppNavigationContext} from "../appNavigation/context/AppNavigationContext";
import {InductLocationContext} from "./context/InductLocationContext";
import {ScanWithInputView} from "dolphin-meridian-react-components";
import {ResponseStatus} from "../utils/ResponseStatus";
import {InductLocationActions} from "./actions/InductLocationActions";
import {Routes} from "../utils/Routes";
import {injectIntl} from "react-intl";
import {updateAlert} from "../utils/utils";

const ScanInductLocationView = (props) => {
    const {state, dispatch} = useContext(InductLocationContext);
    const {navActions: {setupHelp, resetNavCol, errorNavCol, onBackDefault}} = useContext(AppNavigationContext);
    const flow = props.match.params.flow;

    const [alert, setAlert] = useState(null);

    const onSetScanInductLocation = (inputValue) => {
        if (state.locations != null && state.locations.includes(inputValue)) {
            props.history.push(Routes.RECEIVE_PACKAGE_WITHOUT_PROPS + flow + "/" + inputValue);
        }
        else {
            updateAlert(setAlert, resetNavCol, errorNavCol,
                "error", props.intl.formatMessage({id: "location.error.wrong_induct_location"}));
        }
    }

    const clean = () => {
        resetNavCol();
        dispatch({type: InductLocationActions.RESET_RESPONSE});
    }

    useEffect(()  => {
        onBackDefault();
        resetNavCol();
        setupHelp(true, {list: []});
        dispatch({type: InductLocationActions.GET_INDUCT_LOCATIONS, data: {dispatcher: dispatch}});
        return () => clean();
    }, [])

    useEffect(() => {
        if (state.responseStatus === ResponseStatus.ERROR) {
            updateAlert(setAlert, resetNavCol, errorNavCol,
                "error", props.intl.formatMessage({id: "induct_service_error"}));
        }
        else if (state.responseStatus === ResponseStatus.NO_INTERNET) {
            updateAlert(setAlert, resetNavCol, errorNavCol, "error", "No Internet");
        }
        else updateAlert(setAlert, resetNavCol);
    }, [state.responseStatus]);

    return (
        state.responseStatus === ResponseStatus.LOADING ? <Loading /> :
            <Column spacing="none">
                {alert}
                <ScanWithInputView
                    title={props.intl.formatMessage({id: "location.go_to_assigned_induct_location"})}
                    description={props.intl.formatMessage({id: "location.scan_induct_location"})}
                    onSubmit={onSetScanInductLocation}
                />
            </Column>
    )
}

export default injectIntl(ScanInductLocationView);


// WEBPACK FOOTER //
// ./src/components/inductLocation/ScanInductLocationView.js